export const ILISKI_AREN = [
  {
    id: "iar001",
    metin: "{{ad}}, bu iki yüze baktım ve içimden güldüm! {{soru}} konusunda şunu söyleyeyim: bu iki insan birbirini o kadar çok seviyor ki tartışmaktan vakit bulamıyor sevişmeye! Aralarındaki gerilim aslında güçlü bir enerjinin işareti — bu enerji doğru yöne akarsa, inanılmaz bir uyum ortaya çıkar.\n\nO enerjiyi kavgaya değil sevgiye kanalize edin. Aynı enerji, farklı sonuç. Deneyin — bir hafta boyunca her anlaşmazlıkta durun, nefes alın ve 'bu kavgaya değer mi?' diye sorun. Cevap çoğunlukla hayır olacak.",
    tema: "enerji"
  },
  {
    id: "iar002",
    metin: "{{ad}}, bu ilişkiye baktım ve içimden 'ay bu iki inatçı!' dedim! {{soru}} konusunda ikisi de haklı olduğunu düşünüyor, ikisi de geri adım atmak istemiyor. Bu tanıdık geldi mi?\n\nPeki ya ikisi de biraz geri adım atsa? Denediniz mi hiç? İnatta yarışmak yerine çözümde yarışın. Kim önce 'dur, birlikte düşünelim' diyebilir? O kişi aslında kazanan olur.",
    tema: "inat"
  },
  {
    id: "iar003",
    metin: "{{ad}}, bu iki insanın enerjisi bana dans eden çiftleri hatırlattı. {{soru}} konusunda bazen sen öne çıkıyorsun, bazen o — ve bu aslında çok güzel bir ritim.\n\nAma ritmi kaybetmeyin. Dans etmeyi, birlikte hareket etmeyi unutmayın. Her ilişkide iniş çıkışlar olur — önemli olan müziği duymaya devam etmek. Müzik hâlâ çalıyor, sadece biraz daha dikkatli dinleyin.",
    tema: "ritim"
  },
  {
    id: "iar004",
    metin: "{{ad}}, bu ilişkide çok ciddi bir sorun fark ettim! Ne mi? Birlikte çok az gülüyorlar. {{soru}} ne kadar ağır olursa olsun, güler yüzü kaybetmeyin.\n\nBirlikte gülen çiftler birlikte kalır — bu benim kırk yıllık gözlemim. Bugün birlikte kahkaha atacağınız küçük bir şey bulun. Belki aptalca bir şey, belki eski bir anı. O kahkaha, tartışmalardan çok daha fazlasını iyileştirir.",
    tema: "kahkaha"
  },
  {
    id: "iar005",
    metin: "{{ad}}, bu iki insanın arasındaki bağa baktım. {{soru}} konusunda şunu söyleyeyim: bu bağ lastik gibi — ne kadar gererseniz gerin, geri geliyor. Ama her lastik bir gün kopar.\n\nO kopma noktasına getirmeyin birbirinizi. Gerilimi fark ettiğinizde durun. 'Bu bizi nereye götürüyor?' diye sorun. Cevap sizi doğru yöne çekecek.",
    tema: "bag"
  },
  {
    id: "iar006",
    metin: "{{ad}}, bu ilişkide komik bir durum var! {{soru}} konusunda ikisi de birbirinden bir şey bekliyor ama kimse söylemiyor. Sanki karşındaki okuyacak!\n\nSöyleyin. Adını koyun, konuşun. 'Senden şunu bekliyorum' demek ne kadar zor ki? Telepati sadece filmlerde çalışır, gerçek hayatta iletişim şart. Bugün o konuşmayı yapın.",
    tema: "iletisim"
  },
  {
    id: "iar007",
    metin: "{{ad}}, bu iki yüze baktım ve bir sır fark ettim. {{soru}} konusunda biri çok şey hissediyor ama gösteremiyor. Neden? Reddedilme korkusu — bu korku çok şeyi engelliyor.\n\nO korku yüzünden ne kadar güzel an kaçırılıyor? Düşünün. Reddedilmek acıtır ama gösterememek de acıtır — hem de çok daha uzun süre. Bir adım atın. Sonucu ne olursa olsun, en azından bilmiş olursunuz.",
    tema: "korku"
  },
  {
    id: "iar008",
    metin: "{{ad}}, bu ilişki bana iyi bir macera filmi gibi geldi! {{soru}} konusunda iniş çıkışlar var, heyecan var, gerilim var — ama iyi macera filmlerinin mutlu sonu olur.\n\nBu filmin sonu da güzel olabilir — ama bunun için senaryo biraz değişmeli. Hangi sahneyi değiştirmek isterdiniz? O sahneden başlayın. Küçük değişiklikler büyük dönüşümler yaratır.",
    tema: "macera"
  },
  {
    id: "iar009",
    metin: "{{ad}}, bu iki insanın enerjisi bana şunu söylüyor: birbirlerine çok benziyorlar! {{soru}} konusunda benzerlik bazen sürtüşme yaratır — iki güçlü mıknatıs yanlış taraftan yaklaşınca iter.\n\nAma doğru taraftan yaklaşılırsa güçlü bir çekim olur. Benzerliklerinizi düşman değil, müttefik yapın. 'Biz aynıyız' yerine 'biz birbirimizi anlıyoruz' deyin.",
    tema: "benzerlik"
  },
  {
    id: "iar010",
    metin: "{{ad}}, bu ilişkide gizli bir kahkaha kaynağı var — ama şu an gömülü kalmış. {{soru}} konusunda ne kadar ciddi olursa olsun, o gizli kahkahayı bulun.\n\nBirlikte gülebiliyorsanız, her şeyi aşabilirsiniz. Bu benim formülüm. Bugün birbirinize gülümseyin — sadece gülümseyin. Bazen bu kadar yeterli.",
    tema: "hafiflik"
  },
  {
    id: "iar011",
    metin: "{{ad}}, bu iki yüze bakınca aklıma puzzle geldi — ayrı ayrı eksik görünen ama bir araya gelince tam olan parçalar. {{soru}} konusunda birbirlerini tamamlıyorlar, görseler de görmeseler de.\n\nBunu birbirinize söyleyin. 'Sen beni tamamlıyorsun' demek ne güzel bir cümle. Söylenmeyen güzel şeyler de kaybolur — söyleyin.",
    tema: "tamamlanma"
  },
  {
    id: "iar012",
    metin: "{{ad}}, bu ilişkide çok sevimli bir şey var! {{soru}} konusunda ikisi de birbirini düşünüyor — ama bunu söylemiyorlar!\n\nSöyleyin! 'Seni düşünüyorum' demek üç kelime. Üç kelime bu ilişkiyi değiştirebilir. Bugün deneyin — karşılığını görün.",
    tema: "ifade"
  },
  {
    id: "iar013",
    metin: "{{ad}}, bu ilişkiyi okurken hem güldüm hem düşündüm. {{soru}} konusunda bu iki insan birbirini hem çıldırtıyor hem de bayıltıyor — aynı anda!\n\nBu denge çok ince ama çok güzel. Sadece o dengeyi korumayı öğrensinler. Çıldırtıcı anlar geldiğinde 'bu da geçer' deyin. Geçer — ve ardından bayıltıcı anlar gelir.",
    tema: "denge"
  },
  {
    id: "iar014",
    metin: "{{ad}}, bu ilişkide sürpriz enerjisi hissediyorum! {{soru}} konusunda beklenmedik bir gelişme geliyor — bu ilişkiyi sarsacak, ama yıkmayacak.\n\nSürprizlere açık olun. Her sürpriz kötü değildir — bazen en güzel dönemler beklenmedik anlarda başlar. Katı durmayın, akışa bırakın biraz.",
    tema: "surpriz"
  },
  {
    id: "iar015",
    metin: "{{ad}}, bu iki yüze baktım ve şunu düşündüm: bunlar ya çok uyumlu ya çok uyumsuz! Sonra anladım — ikisi de! {{soru}} konusunda hem çok uyumlu hem çok uyumsuz olmak, aslında en ilginç ilişki formülü.\n\nKabul edin birbirinizi — hem uyumlu yanlarıyla hem de uyumsuz yanlarıyla. Mükemmel uyum yoktur, güzel uyum vardır. Güzel uyum ise çabayla kurulur.",
    tema: "kabul"
  },
  {
    id: "iar016",
    metin: "{{ad}}, bu ilişkide kim önce özür dileyecek oyunu oynanıyor! {{soru}} konusunda bu oyunu kim kazanır biliyor musun? İkisi de kaybeder!\n\nİlk özür dileyen aslında kazanır. Çünkü özür dilemek cesaret ister — ve cesur olan güçlüdür. Bugün o cesareti gösterin. 'Üzdüysem özür dilerim' demek hiçbir şeyi kaybettirmez, çok şey kazandırır.",
    tema: "ozur"
  },
  {
    id: "iar017",
    metin: "{{ad}}, bu ilişkide romantizm azalmış — gündelik hayata gömülmüş. {{soru}} konusunda o ilk günleri hatırlıyor musunuz? O titremeleri, o beklentileri?\n\nHâlâ var içinde — sadece örtülmüş. Bugün küçük bir romantik jest yapın — büyük olmak zorunda değil. Bir not, bir sürpriz, bir 'seni düşündüm' mesajı. Küçük şeyler büyük farklar yaratır.",
    tema: "romantizm"
  },
  {
    id: "iar018",
    metin: "{{ad}}, bu iki insanın arasındaki sessizliklere baktım. {{soru}} konusunda o sessizlikler ne anlatıyor? Huzurlu bir sessizlik mi, yoksa söylenemeyen şeylerin yarattığı bir sessizlik mi?\n\nİkinci türden bir sessizlikse — konuşun. Sessizlik bazen koruyucu görünür ama aslında mesafe yaratır. Doldurun o sessizliği — kelimelerle, tebessümle, bir dokunuşla.",
    tema: "sessizlik"
  },
  {
    id: "iar019",
    metin: "{{ad}}, bu ilişkide güzel bir şey gördüm — büyüme. İkisi de birbirinin sayesinde değişiyor, gelişiyor. {{soru}} konusunda bu büyüme bazen acıtır, bazen zorlayıcıdır.\n\nAma bu büyümeyi durdurmayın. Birbirinin en iyi öğretmeni olmak — çok nadir bir armağan. Bu armağanı değerlendirin.",
    tema: "buyume"
  },
  {
    id: "iar020",
    metin: "{{ad}}, bu iki yüzün enerjisi bana şunu söylüyor: çok enerji var bu ilişkide, ama bazen yanlış yöne akıyor. {{soru}} konusunda o enerjiyi kavgadan alıp sevgiye yönlendirin.\n\nAynı enerji, farklı sonuç yaratır. Bugün birbirinize verdiğiniz eleştirinin yarısını övgüye dönüştürün. Ne hissettirdiğini görün.",
    tema: "enerji_yonetimi"
  },
  {
    id: "iar021",
    metin: "{{ad}}, bu ilişkide bir dedektif hikayesi var! {{soru}} konusunda biri bir şey saklıyor — kötü değil, belki bir sürpriz ya da söyleyemediği bir duygu.\n\nO sırrı çözün ama zorlamadan, sevgiyle. Merakla sorun, yargılamadan dinleyin. Güvenli bir atmosfer yarattığınızda sırlar kendiliğinden konuşur.",
    tema: "sir"
  },
  {
    id: "iar022",
    metin: "{{ad}}, bu iki insan birbirlerini özlüyor — birlikte olsalar bile! {{soru}} konusunda bu özlem güzel ama can yakıcı.\n\nÇözüm: daha gerçek, daha kaliteli anlar yaşayın birlikte. Yan yana oturup ayrı ekranlara bakmak değil — gerçekten birlikte olmak. Telefonsuz, dikkatsiz değil — tam ve gerçek.",
    tema: "ozlem"
  },
  {
    id: "iar023",
    metin: "{{ad}}, bu ilişkide kim daha çok seviyor yarışı var! {{soru}} konusunda bu yarışı bırakın. Sevgide yarış olmaz.\n\nKim daha çok severse, o daha çok mutlu olur — bu kadar basit. Sevgiyi ölçmeye çalışmak onu küçültür. Sevmeye odaklanın, ölçmeye değil.",
    tema: "yaris"
  },
  {
    id: "iar024",
    metin: "{{ad}}, bu iki yüze son kez baktım. {{soru}} konusunda şunu söyleyeyim: bu ilişki bir yatırım gibi — ne kadar emek verirseniz, o kadar kazanırsınız.\n\nAma emek vermeyi bırakırsanız değer kaybeder. İlişkiler canlı varlıklardır — beslenmezse solar. Bugün o yatırıma bir şey ekleyin. Küçük de olsa — ama ekleyin.",
    tema: "emek"
  },
  {
    id: "iar025",
    metin: "{{ad}}, sunu söyleyeyim: bu ilişki komik, güzel, zor ve muhteşem — hepsi aynı anda. {{soru}} ne olursa olsun, o muhteşemliği görmeyi bırakmayın.\n\nGerçek aşk böyledir — hepsini bir arada taşır. Kusurlu, zaman zaman yorucu, ama gerçek. Ve gerçek olan en güzeldir. Sahip olduğunuzu görün — kaybetmeden önce.",
    tema: "ask"
  }
];